<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="4">
                    <input type="text" v-model="searchEmail" placeholder="Email PIC" class="form-control"/>
                </CCol>
                <CCol sm="4">
                    <input type="text" v-model="searchNama" placeholder="Nama Perusahaan" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control" v-model="selectedStatus" placeholder="Status"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="3">
                        Nama Perusahaan
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{dataNama}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Email PIC
                    </CCol>
                    <CCol sm="9">
                        : <span>{{dataEmail}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Tanggal Pengajuan
                    </CCol>
                    <CCol sm="9">
                        : <span>{{separatorTanggal(dataTanggal)}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Unit Level
                    </CCol>
                    <CCol sm="9">
                        : <span>{{dataUnitLevel}}</span>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit mt-5">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="deleteModal = true" class="btn mr-2 btn-edit-delete">
                    Reject
                </CButton>
                <CButton @click="approveModal = true" class="btn btn-edit-submit">
                    Approve
                </CButton>
            </CCol>
        </CRow>
        <CModal
            size="sm"
            :centered="true"
            title="Info Reject"
            color="danger"
            :show.sync="deleteModal"
            >
            <p>Apakah anda yakin ingin menolak pengajuan perusahaan?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="goSave('R')" class="btn btn-danger w-100 text-center btn-delete">Ya, Tolak</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="primary"
            :show.sync="approveModal"
            >
            <p>Apakah anda yakin ingin menerima pengajuan perusahaan?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="approveModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="goSave('A')" class="btn btn-primary w-100 text-center">Ya, Setuju</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tablesPerusahaan'
import {DataApi} from "../../../service/DataApi"
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            success: true,
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama Perusahaan', 'Email PIC', 'Tanggal Pengajuan', 'Status', 'Action'],
            dataTd: ['nama', 'emailPic', 'createdDate', 'status', 'action'],
            styleTable: ['150px', '150px', '100px', '75px', '75px'],
            classReload: 'reloadOff',
            goArea: true,
            alertMess: '',
            currentAlertCounter: 0,

            // data model


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchEmail: '',
            searchNama: '',
            selectedStatus: {
                value: '',
                text: ''
            },
            dataStatus: [],
            
            // datas
            datas: [],
            dataEmail: '',
            dataTanggal: '',
            dataNama: '',
            dataUnix: '',
            dataUnitLevel: '',

            //error
            errorMessage: '',
            deleteModal: false,
            approveModal: false,
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchEmail() {
            this.flagSearch = true
        },
        searchNama() {
            this.flagSearch = true
        },
        selectedStatus() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.unitLevel.toLowerCase() < b.unitLevel.toLowerCase()) {
                        return -1
                    }
                    if (a.unitLevel.toLowerCase() > b.unitLevel.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.tglExpired.toLowerCase() < b.tglExpired.toLowerCase()) {
                        return -1
                    }
                    if (a.tglExpired.toLowerCase() > b.tglExpired.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let namaOrganisasi = this.searchValue
            let organisasi = this.searchOrganization
            let page = this.page

            let payload = {
                email: this.searchEmail,
                limit: this.size,
                nama: this.searchNama,
                pageIn: this.page,
                status: this.selectedStatus.value
            }
            DataApi.post("perusahaan/trial/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchValue = ''
            this.searchEmail = ''
            this.searchNama = ''
            this.selectedStatus.value = ''
            this.selectedStatus.text = ''
            this.getDataStatus()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
            }
        },
        goSave(tipe) {
            let payload = {
                status: tipe,
                unix: this.dataUnix
            }
            DataApi.post("perusahaan/trial/approve", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.deleteModal = false
                this.approveModal = false
                this.getData()
                this.moving()
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.dataEmail = generate.emailPic
            this.dataNama = generate.nama
            this.dataTanggal = generate.createdDate
            this.dataUnix = generate.unix
            this.dataUnitLevel = generate.unitLevel
            this.moving()
        },
        separatorTanggal(data) {
            let tanggal = data.split("-")[2]
            let bulanTemp = data.split("-")[1]
            let tahun = data.split("-")[0]
            let bulan = ''
            if(bulanTemp == '01') {
                bulan = 'Jan'
            } else if(bulanTemp == '02') {
                bulan = 'Feb'
            } else if(bulanTemp == '03') {
                bulan = 'Mar'
            } else if(bulanTemp == '04') {
                bulan = 'Apr'
            } else if(bulanTemp == '05') {
                bulan = 'Mei'
            } else if(bulanTemp == '06') {
                bulan = 'Jun'
            } else if(bulanTemp == '07') {
                bulan = 'Jul'
            } else if(bulanTemp == '08') {
                bulan = 'Agu'
            } else if(bulanTemp == '09') {
                bulan = 'Sep'
            } else if(bulanTemp == '10') {
                bulan = 'Okt'
            } else if(bulanTemp == '11') {
                bulan = 'Nov'
            } else if(bulanTemp == '12') {
                bulan = 'Des'
            }
            return tanggal + ' ' + bulan + ' ' + tahun 
        },
        getDataStatus() {
            this.dataStatus = [
                { value: '', text: 'Semua' },
                { value: 'W', text: 'Waiting' },
                { value: 'R', text: 'Rejected' },
                { value: 'A', text: 'Approve' }
            ]
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataStatus()
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}
</style>